/* istanbul ignore file */
import Box from '@mui/material/Box';
import {
  handleOAuthResponse,
  useOktaContext,
  useRefreshAccessToken,
} from 'mf_core/auth';
import { useApiPost } from 'mf_core/query';
import React, { ChangeEvent, useState } from 'react';

export function DebugAccessToken() {
  const { authState, oktaAuth } = useOktaContext();

  // debugging token refresh upon 401 and impersonation mode
  const refreshAccessTokenWithDebuggingData = useRefreshAccessToken(true);
  const refreshAccessTokenHandler = () => {
    refreshAccessTokenWithDebuggingData().then((success) => {
      // eslint-disable-next-line no-console
      console.log(`access token refresh ${success ? 'succeeded' : 'faield'}`);
    });
  };

  const invalidateAccessTokenHandler = () => {
    const tokens = oktaAuth.tokenManager.getTokensSync();
    if (tokens.accessToken) {
      tokens.accessToken.accessToken =
        tokens.accessToken.accessToken.concat('invalidated');
      oktaAuth.tokenManager.setTokens(tokens);
      // eslint-disable-next-line no-console
      console.log('tokens: ', tokens);
    }
  };

  const invalidateRefreshTokenHandler = () => {
    const tokens = oktaAuth.tokenManager.getTokensSync();
    if (tokens.refreshToken && authState?.refreshToken) {
      const inv = 'invalidated';
      tokens.refreshToken.refreshToken = inv;
      authState.refreshToken.refreshToken = inv;
      oktaAuth.tokenManager.setTokens(tokens);
      // eslint-disable-next-line no-console
      console.log('tokens: ', tokens);
    }
  };

  const [resellerIdInputValue, setResellerIdInputValue] = useState('');
  const handleResellerIdChange = (e: ChangeEvent<HTMLInputElement>) => {
    setResellerIdInputValue(e.target.value);
  };
  const apiPost = useApiPost();
  const enableImpersonationHandler = () => {
    apiPost(
      //`https://apixgcp-qa.ingrammicro.com/impersonation/v2/x4c/enable/${resellerIdInputValue}`,
      `/impersonation/v2/x4c/enable/${resellerIdInputValue}`,
      {
        tokenRefreshRequest: {
          authority: authState?.refreshToken?.issuer,
          clientId: authState?.idToken?.clientId,
          refreshToken: authState?.refreshToken?.refreshToken,
          scope: authState.refreshToken?.scopes.join(' '),
        },
      }
    ).then((data) => {
      const tokenResponse = data?.tokenRefreshResponse;
      if (tokenResponse) {
        const tokenParams = { clientId: authState?.idToken?.clientId };
        handleOAuthResponse(oktaAuth, tokenParams, tokenResponse, null).then(
          (convertedResponse: any) => {
            const { tokens } = convertedResponse;
            // eslint-disable-next-line no-console
            console.log(
              'new tokens built from impersonation API response: ',
              tokens
            );
            oktaAuth?.tokenManager.setTokens(tokens);
          }
        );
      }
    });
  };
  const showDebug = localStorage.getItem('showDebug');
  // end debugging

  return (
    <>
      {showDebug && (
        <Box>
          <button onClick={invalidateAccessTokenHandler}>
            invalidate access token
          </button>
          &nbsp;
          <button onClick={invalidateRefreshTokenHandler}>
            invalidate refresh token
          </button>
          &nbsp;
          <button onClick={refreshAccessTokenHandler}>
            refresh access token
          </button>
          <br />
          <input
            onChange={handleResellerIdChange}
            placeholder="reseller id"
            type="text"
            value={resellerIdInputValue}
          ></input>
          <button onClick={enableImpersonationHandler}>
            enable impersonation
          </button>
        </Box>
      )}
    </>
  );
}
